import { certificateTemplateList, traineesCertificate, } from "constants/certificate";

const initialState = {
  certificateTemplateList: {},
  traineesCertificate: {},
};

const certificate = (state = initialState, action) => {
  switch (action.type) {
    case certificateTemplateList:
      return { ...state, certificateTemplateList: action.payload };

    case traineesCertificate:
      return { ...state, traineesCertificate: action.payload };

    default:
      return state;
  }
};

export default certificate;